import { redirectTo } from "../../utils/httpHelper";
import {
  verifyTransaction,
  generateDpoPayPortal,
  purchasePPVOrder,
  purchaseSubscription,
  verifyCouponCode,
  fetchPaypalAccessToken,
  createPaypalOrder,
  capturePaypalOrder,
  checkOrCreatePaypalProduct,
  createPaypalSubscriptionPlan,
  createPaypalSubscription,
  getPaypalSubscriptionDetails,
  getSavedPaymentMethods,
  deleteSavedPaymentMethod
} from "../../services/paymentService";
import { formatUrl } from "../../utils/domHelper";
import { getGatewayActive } from "../../services/paymentService";
import { isAuth } from "../../utils/authHelper";
import {
  createStripePurchaseCard,
  stripeAddCardFields,
} from "../../components/PPV/StripePurchaseCard";
import {
  createAuthorizeNetPurchaseCard,
  authorizeNetAddCardFields,
} from "../../components/PPV/AuthorizeNetPurchaseCard";
import { createDPOPayPurchaseCard } from "../../components/PPV/DPOPayPurchaseCard";
import { createPaypalPurchaseCard } from "../../components/PPV/PaypalPurchaseCard";
import { createCardForm } from "../../utils/authorizeNetCardForm";
import { AppConfig } from "../../constants/config";

let selectedPlan = null;

// PPV
export const registerPayment = async (
  baseUrl,
  apiKey,
  data,
  container,
  is_subscription = false
) => {
  const activeGW = await getGatewayActive(baseUrl, apiKey);
  if (activeGW) {
    if (activeGW.gateway_provider == 1) {
      let client_id = activeGW.credential_information.client_id;
      let client_secret = activeGW.credential_information.client_secret;
      paypalPayment(
        baseUrl,
        apiKey,
        client_id,
        client_secret,
        data,
        container,
        is_subscription
      );
    }
    else if (activeGW.gateway_provider == 2) {
      let stripeApiKey = activeGW.credential_information.publishable_api_key;
      stripePayment(
        baseUrl,
        apiKey,
        stripeApiKey,
        data,
        container,
        is_subscription
      );
    } else if (activeGW.gateway_provider == 3) {
      let authorizeNetLoginId = activeGW.credential_information.api_login_id;
      let authorizeNetPublicClientKey = activeGW.credential_information.public_client_key;
      let isSandbox = activeGW.is_sandbox || false;
      authorizeNetPayment(
        baseUrl,
        apiKey,
        authorizeNetLoginId,
        authorizeNetPublicClientKey,
        data,
        container,
        is_subscription,
        isSandbox
      );
    } else if (activeGW.gateway_provider == 4) {
      const companyToken = activeGW.credential_information.company_token;
      const serviceToken = activeGW.credential_information.service;
      dpoPayPayment(
        baseUrl,
        apiKey,
        companyToken,
        serviceToken,
        data,
        container,
        is_subscription);
    }
  }
};

// PayPal Payment
async function paypalPayment(baseUrl, apiKey, client_id, client_secret, data, container, is_subscription) 
{
  const isLogged = isAuth();
  // Render the payment form
  $(container).html(createPaypalPurchaseCard(data, is_subscription, { isLoggedIn: isLogged }));
  const form = $(container).find(".purchase-card");
  const submitButton = $(container).find("#paypal-submit-payment");

  // submitButton.html(is_subscription ? "Proceed to Payment" : "Subscribe");
  submitButton.html("Subscribe");

  // Event listener for plan dropdown
  const planSelect = form.find("select[name='plan_id']");
  planSelect.on("change", function () {
    const selectedPlanId = $(this).val();
    const selectedPlan = data.find((plan) => plan.uuid === selectedPlanId);

    if (selectedPlan?.is_free) {
      submitButton.html("Subscribe");
    } else {
      submitButton.html(is_subscription ? "Proceed to Payment" : "Subscribe");
    }
  });

  // Handle form submission
  submitButton.on("click", async (event) => {
    event.preventDefault();

    const errorDiv = $("#paypal-card-errors");
    errorDiv.text(""); // Clear any existing error messages

    // Extract form values
    const planId = is_subscription ? form.find("select[name='plan_id']").val() : null;
    const firstName = form.find("input[name='first_name']").val().trim();
    const lastName = form.find("input[name='last_name']").val().trim();
    const email = form.find("input[name='email']").val().trim();
    const password = form.find("input[name='password']").val().trim();

    // Validate form inputs
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const validationMessage = !firstName
      ? "Please enter your first name."
      : !lastName
      ? "Please enter your last name."
      : !emailRegex.test(email)
      ? "Please enter a valid email address."
      : !password
      ? "Please enter your password."
      : is_subscription && !planId
      ? "Please select a plan."
      : null;

    if (validationMessage) {
      errorDiv.text(validationMessage);
      return;
    }

    // Find the selected plan (if subscription)
    const selectedPlan = is_subscription
      ? data.find((plan) => plan.uuid === planId)
      : data;

    if (!selectedPlan) {
      errorDiv.text("Selected plan not found.");
      return;
    }

    try {
      if (is_subscription && selectedPlan.is_free) {
        const payload = {
          email,
          first_name: firstName,
          last_name: lastName,
          password,
          uuid: planId,
          is_free: true
        };

        const response = await purchaseSubscription(baseUrl, apiKey, JSON.stringify(payload));

        if (response?.credentials) {
          localStorage.setItem("loginToken", JSON.stringify(response.credentials));
          window.location.reload();
        } else {
          errorDiv.text("An error occurred while processing your subscription.");
        }
        return;
      }

      if (is_subscription) {
        const accessToken = await fetchPaypalAccessToken(baseUrl, apiKey, client_id, client_secret);
        // Ensure product exists or create it
        const productData = {
          name: selectedPlan.title,
          id: selectedPlan.uuid,
          description: selectedPlan.description || "Subscription Plan",
          category: "SOFTWARE",
          image_url: selectedPlan.image_url || "https://example.com/default.jpg",
          home_url: "https://example.com",
        };

        const product = await checkOrCreatePaypalProduct(baseUrl, apiKey, accessToken, productData);

        // Create subscription plan
        const planData = {
          product_id: product.product_id,
          name: selectedPlan.title,
          description: selectedPlan.title,
          trial_in: selectedPlan.trial_in,
          regular_price: selectedPlan.price,
          currency: selectedPlan.price_currency,
          expires_in: selectedPlan.expires_in,
        };

        const plan = await createPaypalSubscriptionPlan(baseUrl, apiKey, accessToken, planData);

        const currentUrl = `${window.location.protocol}//${window.location.host}`;

        const subscriptionData = {
          plan_id: plan.id,
          subscriber_name: `${firstName} ${lastName}`,
          email_address: email,
          return_url: `${currentUrl}/thank-you`,
          cancel_url: "htps://example.com/cancel",
        };

        const subscription = await createPaypalSubscription(baseUrl, apiKey, accessToken, subscriptionData);

        // Ensure the subscription object has the approval_url before proceeding
        if (subscription && subscription.links) {
          const approvalLink = subscription.links.find(link => link.rel === "approve");

          if (approvalLink) {
            const popup = window.open(approvalLink.href, "_blank", "width=600,height=800");

            const interval = setInterval(async () => {
              if (popup.closed) {
                clearInterval(interval);

                try {
                  const subscriptionDetails = await getPaypalSubscriptionDetails(baseUrl, apiKey, accessToken, subscription.id);

                  if (subscriptionDetails?.status === "ACTIVE") {

                    // Construct the payload for processing the subscription
                    const payload = {
                      subscriptionId: subscription.id,
                      email,
                      first_name: firstName,
                      last_name: lastName,
                      password,
                      uuid: planId,
                      subscriptionDetails: subscriptionDetails,
                    };

                    // Send the payload to the server
                    const response = await purchaseSubscription(baseUrl, apiKey, JSON.stringify(payload));

                    // Handle the response
                    if (response?.credentials) {
                      localStorage.setItem("loginToken", JSON.stringify(response.credentials));
                      window.location.reload();
                    } else {
                      errorDiv.text("An error occurred while processing your subscription.");
                    }
                  } else {
                    errorDiv.text("Subscription is not active.");
                  }
                } catch (error) {
                  console.error("Error checking subscription status:", error);
                  errorDiv.text("Payment Failed, please try again.");
                }
              }
            }, 500);
          } else {
            errorDiv.text("Approval URL not available for subscription.");
          }
        } else {
          errorDiv.text("Invalid subscription data.");
        }
      } else {
        const accessToken = await fetchPaypalAccessToken(baseUrl, apiKey, client_id, client_secret);

        const currentUrl = `${window.location.protocol}//${window.location.host}`;

        const orderPayload = {
          accessToken: accessToken,
          intent: "CAPTURE",
          purchase_units: [
            {
              amount: {
                currency_code: selectedPlan.price_currency,
                value: selectedPlan.price,
              },
              description: selectedPlan.title,
            },
          ],
          application_context: {
            return_url: `${currentUrl}/thank-you`,
            cancel_url: "https://example.com/cancel",
          },
        };

        const { orderId, approvalUrl } = await createPaypalOrder(baseUrl, apiKey, orderPayload);

        if (approvalUrl) {
          const popup = window.open(approvalUrl, "_blank", "width=600,height=800");

          const interval = setInterval(async () => {
            if (popup.closed) {
              clearInterval(interval);
              try {
                const { success, response_data } = await capturePaypalOrder(baseUrl, apiKey, accessToken, orderId);
                if (success) {
                  errorDiv.text("Payment successfully captured. You can proceed.");
                  const payload = {
                    OrderId: orderId,
                    VerificationDetails: response_data,
                    email,
                    first_name: firstName,
                    last_name: lastName,
                    password,
                  };

                  if (is_subscription) {
                    payload["uuid"] = plan_id;
                    // Include coupon code for subscription if applied
                    if (selectedPlan.applied_coupon_code) {
                      payload["offer_code"] = selectedPlan.applied_coupon_code;
                    }
                  } else {
                    payload["uuid"] = data.uuid;
                    payload["content_type"] = data.content_type;
                    // Include coupon code for PPV purchase if applied
                    if (selectedPlan.applied_coupon_code) {
                      payload["offer_code"] = selectedPlan.applied_coupon_code;
                    }
                  }
                  const response = await purchasePPVOrder(baseUrl, apiKey, JSON.stringify(payload));

                  if (response?.credentials) {
                    localStorage.setItem("loginToken", JSON.stringify(response.credentials));
                    window.location.reload();
                  } else {
                    errorDiv.text("An error occurred while processing your request.");
                  }
                } else {
                  errorDiv.text("Payment failed please retry.");
                }
              } catch (captureError) {
                console.error("Error capturing PayPal order:", captureError);
                errorDiv.text("An error occurred while capturing the payment. Please contact support.");
              }
            }
          }, 500);
        } else {
          errorDiv.text("Approval URL not available.");
          console.error("Approval URL not available.");
        }
      }
    } catch (error) {
      console.error("Error creating PayPal order:", error);
      errorDiv.text("An error occurred while processing your request. Please try again.");
    }

  });

  $("#closePaypalPurchaseCard").on("click", closePaymentForm);

  function closePaymentForm() {
    $("#PaypalPurchaseCard, #paypal-card-element .payment-form").remove();
  }
}

// Stripe Payment
async function stripePayment(
  baseUrl,
  apiKey,
  stripeApiKey,
  data,
  container,
  is_subscription
) {
  let isLogged = isAuth();
  let loginToken = JSON.parse(localStorage.getItem("loginToken") || "{}");
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  let stripeForm = null;
  let savedCards = [];

  // Fetch saved cards if logged in (for repeat purchases)
  if (isLogged) {
    try {
      const savedCardsResponse = await getSavedPaymentMethods(baseUrl, apiKey);
      if (savedCardsResponse.gateway === 'stripe' && savedCardsResponse.saved_cards?.length > 0) {
        savedCards = savedCardsResponse.saved_cards;
        console.log("[Stripe] Found saved cards for repeat purchase:", savedCards.length);
      }
    } catch (err) {
      console.log("[Stripe] No saved cards found or error fetching:", err);
    }
  }

  const script_script = document.createElement("script");
  script_script.src = "https://js.stripe.com/v3/";
  script_script.async = true;

  // Load stripe script
  script_script.addEventListener("load", () => {
    $(createStripePurchaseCard(data, is_subscription, { savedCards, isLoggedIn: isLogged })).appendTo(container);

    var planSelect = document.getElementById('plan_value');
    var submitButtonText = "Submit Payment"
    var addCardFields = false;

    // Note: Plan change handler for showing/hiding card fields is inside initStripe()
    // where it has access to the cardElement for mounting

    if ($.type(data) === "array") {
      // initStripe(true, "Submit Payment", data[0]);
      const selectPlanDropdown = $('select[name="plan_id"]');

      if (data.length > 1) {
        selectedPlan = data[0];
        selectPlanDropdown.val(selectedPlan.uuid);
        selectPlanDropdown.change(function () {
          selectedPlan = data.find((item) => item.uuid === this.value);
          submitButtonText = "Submit Payment";
          if (selectedPlan.is_free) {
            submitButtonText = "Subscribe";
          } else {
            submitButtonText = "Submit Payment";
            addCardFields = true;
          }
        });
      } else if (data.length === 1) {
        // If there's only one plan, select it by default and trigger the change event
        selectedPlan = data[0];
        selectPlanDropdown.val(selectedPlan.uuid).change();
        submitButtonText = "Submit Payment";
        if (selectedPlan.is_free) {
          submitButtonText = "Subscribe";
        } else {
          submitButtonText = "Submit Payment";
          addCardFields = true;
        }
      }
    } else {
      // Single plan
      selectedPlan = data;
      submitButtonText = "Submit Payment";
      if (selectedPlan.is_free) {
        submitButtonText = "Subscribe";
      } else {
        submitButtonText = "Submit Payment";
        addCardFields = true;
      }
    }

    if (addCardFields) {
      stripeAddCardFields();
    }

    initStripe(is_subscription, submitButtonText, selectedPlan);
  });

  document.head.appendChild(script_script);

  // init Stripe
  async function initStripe(is_subscription, submitButtonText="Submit Payment", selectedPlan) {
    const stripe = Stripe(stripeApiKey);
    const elements = stripe.elements();
    let cardElement = elements.create("card", {
      hidePostalCode: true,
    });

    // On Submit Payment Form
    let errorDiv = $("#stripe-card-errors");
    stripeForm = $("#stripe-payment-form");
    let submitButton = $("#stripe-submit-payment");
    let stripeCardField = document.getElementById('stripe-credit-card-field');
    const savedCardSelect = $("#saved_card_select");
    const newCardSection = $("#new-card-section");
    const nameFieldsSection = $("#form-Info-Box").first();

    stripeCardField.style.display = 'none';
    submitButton.html("Subscribe");

    if (isLogged) {
      let user_email = loginToken.user
        ? loginToken.user.email
        : loginToken.profile.email;
      $("#email").val(user_email).attr("disabled", true);
      
      // Also pre-fill name fields if available
      let user_first_name = loginToken.user?.first_name || loginToken.profile?.first_name || '';
      let user_last_name = loginToken.user?.last_name || loginToken.profile?.last_name || '';
      if (user_first_name) {
        $("#first_name").val(user_first_name);
      }
      if (user_last_name) {
        $("#last_name").val(user_last_name);
      }
      
      // Hide password field for logged-in users
      $("#password").closest(".col").hide();
    }
    
    // Handle saved card selection toggle
    if (savedCardSelect.length > 0) {
      // Initially hide new card section AND name fields if a saved card is selected (first saved card is default)
      const initialSelectedValue = savedCardSelect.val();
      if (initialSelectedValue) {
        newCardSection.hide();
        nameFieldsSection.hide(); // Hide name fields for repeat purchase
        // Show coupon field for paid plans
        if (!selectedPlan.is_free) {
          $("#coupon-field").show();
        }
        console.log("[Stripe] Using saved card by default:", initialSelectedValue);
      }
      
      // Custom dropdown toggle handler
      const customDropdownSelected = $("#custom-dropdown-selected");
      const customDropdownOptions = $("#custom-dropdown-options");
      
      // Toggle dropdown on click
      customDropdownSelected.on("click", function(e) {
        e.stopPropagation();
        customDropdownOptions.toggle();
      });
      
      // Close dropdown when clicking outside
      $(document).on("click", function(e) {
        if (!$(e.target).closest(".custom-card-dropdown").length) {
          customDropdownOptions.hide();
        }
      });
      
      // Handle option selection (click on option text, not the remove button)
      customDropdownOptions.on("click", ".custom-dropdown-option", function(e) {
        // Don't process if clicking on the remove button
        if ($(e.target).hasClass("remove-card-btn")) {
          return;
        }
        
        const $option = $(this);
        const selectedValue = $option.data("value");
        const selectedText = $option.find(".option-text").text();
        const customerId = $option.data("customer-id");
        
        // Update hidden select
        savedCardSelect.val(selectedValue).trigger("change");
        
        // Update custom dropdown display
        $(".selected-card-text").text(selectedText);
        $(".custom-dropdown-option").removeClass("selected");
        $option.addClass("selected");
        
        // Close dropdown
        customDropdownOptions.hide();
      });
      
      // Handle saved card select change (for both custom dropdown and programmatic changes)
      savedCardSelect.on("change", function() {
        const selectedValue = $(this).val();
        
        if (selectedValue) {
          // A saved card is selected - hide new card form and name fields
          newCardSection.hide();
          stripeCardField.style.display = 'none';
          nameFieldsSection.hide(); // Hide name fields for repeat purchase
          // Show coupon field for paid plans
          if (!selectedPlan.is_free) {
            $("#coupon-field").show();
          }
        } else {
          // "Use a new card" selected - show new card form and name fields
          newCardSection.show();
          if (!selectedPlan.is_free) {
            stripeCardField.style.display = 'flex';
            stripeAddCardFields();
            // Mount card element (try-catch in case already mounted)
            try {
              cardElement.mount("#stripe-card-element");
            } catch (e) {
              console.log("[Stripe] Card element already mounted or error:", e);
            }
          }
          // Show name fields only if not logged in
          if (!isLogged) {
            nameFieldsSection.show();
          }
        }
      });
      
      // Handle remove card button click (inside dropdown options)
      customDropdownOptions.on("click", ".remove-card-btn", async function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const $btn = $(this);
        const paymentMethodId = $btn.data("payment-id");
        
        if (!paymentMethodId) {
          console.log("[Stripe] No payment method ID found on button");
          return;
        }
        
        $btn.prop("disabled", true).text("...");
        
        try {
          const result = await deleteSavedPaymentMethod(baseUrl, apiKey, paymentMethodId);
          
          if (result.success) {
            console.log("[Stripe] Payment method removed successfully");
            
            // Remove from hidden select
            savedCardSelect.find(`option[value="${paymentMethodId}"]`).remove();
            
            // Remove the option from custom dropdown
            const $option = $btn.closest(".custom-dropdown-option");
            const wasSelected = $option.hasClass("selected");
            $option.remove();
            
            // Update the saved cards array
            savedCards = savedCards.filter(card => 
              (card.id || card.payment_method_id) !== paymentMethodId
            );
            
            // Check if there are any saved cards left
            const remainingCards = customDropdownOptions.find(".custom-dropdown-option[data-is-saved-card='true']").length;
            if (remainingCards === 0) {
              // No more saved cards - hide the entire saved cards section and show new card form
              $("#saved-cards-section").hide();
              newCardSection.show();
              if (!selectedPlan.is_free) {
                stripeCardField.style.display = 'flex';
                stripeAddCardFields();
                try {
                  cardElement.mount("#stripe-card-element");
                } catch (e) {
                  console.log("[Stripe] Card element already mounted or error:", e);
                }
              }
              if (!isLogged) {
                nameFieldsSection.show();
              }
            } else if (wasSelected) {
              // The removed card was selected, select the first remaining saved card
              const $firstOption = customDropdownOptions.find(".custom-dropdown-option[data-is-saved-card='true']").first();
              const newValue = $firstOption.data("value");
              const newText = $firstOption.find(".option-text").text();
              
              savedCardSelect.val(newValue).trigger("change");
              $(".selected-card-text").text(newText);
              $(".custom-dropdown-option").removeClass("selected");
              $firstOption.addClass("selected");
            }
            
            // Close the dropdown
            customDropdownOptions.hide();
            
            // Show success message below the payment method dropdown
            const messageDiv = $('<div class="payment-method-message success-message">Card removed successfully</div>');
            $("#saved-cards-section").append(messageDiv);
            setTimeout(() => messageDiv.remove(), 3000);
          } else {
            console.error("[Stripe] Failed to remove payment method:", result.message);
            
            // Close the dropdown
            customDropdownOptions.hide();
            
            const messageDiv = $('<div class="payment-method-message error-message">' + (result.message || "Failed to remove card") + '</div>');
            $("#saved-cards-section").append(messageDiv);
            setTimeout(() => messageDiv.remove(), 3000);
          }
        } catch (err) {
          console.error("[Stripe] Error removing payment method:", err);
          
          // Close the dropdown
          customDropdownOptions.hide();
          
          const messageDiv = $('<div class="payment-method-message error-message">An error occurred while removing the card</div>');
          $("#saved-cards-section").append(messageDiv);
          setTimeout(() => messageDiv.remove(), 3000);
        } finally {
          $btn.prop("disabled", false).text("×");
        }
      });
    }

    // Handle plan dropdown change to show/hide card fields when switching between free and paid plans
    const planSelectElement = document.getElementById('plan_value');
    if (planSelectElement) {
      planSelectElement.addEventListener('change', function() {
        var selectedOption = this.options[this.selectedIndex];
        var selectedPrice = selectedOption.getAttribute('data-price');
        var isPaidPlan = parseFloat(selectedPrice) > 0;
        var couponField = document.getElementById('coupon-field');
        
        // Update selected plan reference
        if (Array.isArray(data)) {
          selectedPlan = data.find((item) => item.uuid === this.value);
        }

        if (isPaidPlan) {
          // Show card field and coupon for paid plans
          stripeCardField.style.display = 'flex';
          submitButton.html("Submit Payment");
          
          // Add coupon field if not already present
          if (!$(".coupon_field").find("#coupon_code").length) {
            $(".coupon_field").html(`<div class="form-row" style="text-align: left">
              <div class="colOne">
                <input type="coupon_code" id="coupon_code" name="coupon_code" style="width:100%" required, placeholder="Coupon Code">
              </div>
              <div class="colTwo">
                <button type="button" id="coupon_apply_btn" class="coupon_apply_btn">Apply</button>
              </div>
            </div>`);
          }
          if (couponField) {
            couponField.style.display = 'block';
          }
          
          // Add card element container if not present and mount
          if (!$("#stripe-card-element").length) {
            $(".card_fields").html(`<div class="form-row" style="margin-bottom: 12px;margin-top: 15px">
              <label for="stripe-card-element">Credit or debit card</label>
              <div id="stripe-card-element" style="width:100%"></div>
            </div>`);
          }
          
          // Mount card element (try-catch in case already mounted)
          try {
            cardElement.mount("#stripe-card-element");
          } catch (e) {
            console.log("[Stripe] Card element already mounted or error:", e.message);
          }
        } else {
          // Hide card field and coupon for free plans
          stripeCardField.style.display = 'none';
          submitButton.html("Subscribe");
          if (couponField) {
            couponField.style.display = 'none';
          }
        }
      });
    }

    if (!selectedPlan.is_free) {
      // Add coupon field for all non-free plans (regardless of saved card usage)
      $(".coupon_field").html(`<div class="form-row" style="text-align: left">
        <div class="colOne">
          <input type="coupon_code" id="coupon_code" name="coupon_code" style="width:100%" required, placeholder="Coupon Code">
        </div>
        <div class="colTwo">
          <button type="button" id="coupon_apply_btn" class="coupon_apply_btn">Apply</button>
        </div>
      </div>`);
      
      // Only show card fields if no saved card is selected OR no saved cards available
      const usingSavedCard = savedCardSelect.length > 0 && savedCardSelect.val();
      if (!usingSavedCard) {
        stripeCardField.style.display = 'flex';
        submitButton.html("Submit Payment");
        // Add card fields (no need to call stripeAddCardFields since we already added coupon above)
        $(".card_fields").html(`<div class="form-row" style="margin-bottom: 12px;margin-top: 15px">
          <label for="stripe-card-element">Credit or debit card</label>
          <div id="stripe-card-element" style="width:100%"></div>
        </div>`);
        cardElement.mount("#stripe-card-element");
      } else {
        submitButton.html("Submit Payment");
      }
    }
    submitButton.on("click", function (event) {
      event.preventDefault();

      // Get the currently selected plan from form data
      var formData = new FormData(event.currentTarget.form);
      formData = Object.fromEntries(formData);
      let currentSelectedPlan;

      if (Array.isArray(data)) {
        currentSelectedPlan = data.find(item => item.uuid === formData.plan_id);
      } else if (data && typeof data === "object") {
        if (data.uuid) {
          currentSelectedPlan = data;
        } else {
          currentSelectedPlan = null;
        }
      } else {
        console.error("Unexpected data format. Expected array or object.", data);
        currentSelectedPlan = null;
      }

      submitButton.attr("disabled", true);
      submitButton.html("Processing...");

      errorDiv.html("");
      let email = stripeForm.find("#email").val();
      let first_name = stripeForm.find("#first_name").val();
      let last_name = stripeForm.find("#last_name").val();
      let password = stripeForm.find("#password").val();
      let coupon_code = stripeForm.find("#coupon_code").val();
      
      // Check if using saved card FIRST (before validation)
      const selectedSavedCard = savedCardSelect.length > 0 ? savedCardSelect.val() : null;
      const usingSavedCard = selectedSavedCard && isLogged;

      // Trim all fields
      const trimmedFirstName = first_name ? first_name.trim() : '';
      const trimmedLastName = last_name ? last_name.trim() : '';
      const trimmedPassword = password ? password.trim() : '';
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      let isValid = true;
      let validationMessage = "Required Fields are missing!";

      // Validate other fields - name fields only required if NOT using saved card AND NOT logged in
      // Logged-in users will use their profile name, so we don't require them to enter it again
      if (!usingSavedCard && !isLogged && trimmedFirstName === "") {
        isValid = false;
        validationMessage = "Enter your first name!";
      }

      if (!usingSavedCard && !isLogged && trimmedLastName === "") {
        isValid = false;
        validationMessage = "Enter your last name!";
      }

      if (!emailRegex.test(email)) {
        isValid = false;
        validationMessage = "Enter a valid email address!";
      }

      // Password only required if not logged in
      if (!isLogged && trimmedPassword === "") {
        isValid = false;
        validationMessage = "Enter your password!";
      }
      
      if (!isValid) {
        submitButton.attr("disabled", false);
        submitButton.html(submitButtonText);
        errorDiv.html(validationMessage);
        return false;
      }

      // For logged-in users, use their profile name (whether using saved card or new card)
      let payloadFirstName = first_name;
      let payloadLastName = last_name;
      
      if (isLogged) {
        // Use profile name for logged-in users
        payloadFirstName = loginToken.user?.first_name || loginToken.profile?.first_name || first_name;
        payloadLastName = loginToken.user?.last_name || loginToken.profile?.last_name || last_name;
      }
      
      let payload = {
        email: email,
        first_name: payloadFirstName,
        last_name: payloadLastName,
        password: password,
        uuid: currentSelectedPlan.uuid,
      };
      if (
        coupon_code !== undefined &&
        coupon_code !== "" &&
        coupon_code !== null
      ) {
        payload["coupon_code"] = coupon_code;
      }

      // Include applied coupon code if exists
      if (currentSelectedPlan.applied_coupon_code) {
        payload["offer_code"] = currentSelectedPlan.applied_coupon_code;
      }

      if (
        params.hasOwnProperty("deviceType") &&
        params.hasOwnProperty("deviceId")
      ) {
        payload["deviceType"] = params.deviceType;
        payload["deviceId"] = params.deviceId;
      }

      if (is_subscription && currentSelectedPlan.is_free) {
        capturePayment(payload, submitButton, currentSelectedPlan);
      } else if (usingSavedCard) {
        // SAVED CARD PAYMENT - bypass Stripe.js tokenization
        const selectedOption = savedCardSelect.find("option:selected");
        const customerId = selectedOption.data("customer-id");
        
        payload.saved_payment_profile = {
          customer_id: customerId,
          payment_method_id: selectedSavedCard
        };
        
        console.log("[Stripe] Processing saved card payment:", payload.saved_payment_profile);
        processSavedCardPayment(payload, submitButton, currentSelectedPlan, is_subscription);
      } else {
        stripeCard(stripe, cardElement, payload, submitButton, currentSelectedPlan);
      }
    });

    // close popup form
    $("#closeStripePurchaseCard").click(function () {
      $("#stripePurchaseCard").remove();
    });

    // Apply coupon code
    $("#coupon_apply_btn").on("click", function () {
      applyCouponCode(stripeForm.find("#coupon_code").val());
    });
  }

  // Process Saved Card Payment (repeat purchase)
  async function processSavedCardPayment(payload, submitButton, currentSelectedPlan, is_subscription) {
    // Add content_type for PPV purchases (same as regular capturePayment)
    if (!is_subscription) {
      payload["content_type"] = currentSelectedPlan.content_type;
    }
    
    // Use the SAME capturePayment function to ensure consistent handling
    capturePayment(payload, submitButton, currentSelectedPlan);
  }

  // Stripe Card
  async function stripeCard(stripe, cardElement, payload, submitButton, currentSelectedPlan) {
    stripe
      .createPaymentMethod({
        type: "card",
        card: cardElement,
        billing_details: {
          name: `${payload["first_name"]} ${payload["last_name"]}`,
          email: payload["email"],
        },
      })
      .then(async function (result) {
        if ("paymentMethod" in result) {
          payload["payment_method_id"] = result.paymentMethod.id;
          capturePayment(payload, submitButton, currentSelectedPlan);
        } else {
          submitButton.attr("disabled", false);
          submitButton.html("Submit Payment");
        }
      });
  }

  // Capture Payment
  async function capturePayment(payload, submitButton, currentSelectedPlan) {
    let res;
    if (is_subscription) {
      res = await purchaseSubscription(
        baseUrl,
        apiKey,
        JSON.stringify(payload)
      );
    } else {
      payload["content_type"] = currentSelectedPlan.content_type;
      res = await purchasePPVOrder(baseUrl, apiKey, JSON.stringify(payload));
    }

    if (res !== undefined) {
      if ("credentials" in res && res.credentials) {
        localStorage.setItem("loginToken", JSON.stringify(res.credentials));
        isLogged = true;
        loginToken = res.credentials;
      }
      $("#stripePurchaseCard").remove();

      if (window.location.href.indexOf("/purchase-ppv-event") !== -1) {
        let current_datetime = moment();
        let event_datetime = moment(selectedPlan.event_dates.lower);
        let diff_datetime = current_datetime.diff(event_datetime, "minuts");
        if (diff_datetime >= 0) {
          $(".ppv-event-banner-btn")
            .html("Watch Now")
            .addClass("ppv_event_watch_live_btn");
        } else {
          $(".ppv-event-banner-btn").remove();
          $(".ppv-event-banner-btn-wrapper").html(`
            <p style="color:green">
              This event will start at ${moment(
                selectedPlan.event_dates.lower
              ).format("hh:mm A")} on ${moment(
            selectedPlan.event_dates.lower
          ).format("ll")} you will be able to watch it by going to this page 
              <b><a href="#" class="ppv_event_watch_live_btn">${
                selectedPlan.title
              }</a></b>
            </p>
          `);
        }

        $(".ppv_event_watch_live_btn").on("click", function () {
          const nextURL = `/watch-live`;
          window.location = formatUrl(nextURL);
        });
      } else {
        window.location.reload();
      }
    } else {
      console.log("error");
      console.log(res);
    }

    submitButton.attr("disabled", false);
    submitButton.html("Submit Payment");
  }

  // Apply Coupon Code
  async function applyCouponCode(coupon_code) {
    if (!stripeForm || stripeForm.length === 0) {
      console.error("Stripe form not initialized, cannot apply coupon.");
      return;
    }
    // Get the currently selected plan from the form
    let currentSelectedPlan;
    if (Array.isArray(data)) {
      const selectedPlanId = stripeForm.find("select[name='plan_id']").val();
      currentSelectedPlan = data.find(item => item.uuid === selectedPlanId);
    } else if (data && typeof data === "object") {
      currentSelectedPlan = data;
    } else {
      console.error("Unexpected data format for coupon code application.");
      return;
    }

    if (!currentSelectedPlan) {
      console.error("No plan selected for coupon code application.");
      return;
    }

    // Determine the correct UUID field based on whether this is a subscription or PPV purchase
    let payload = {};
    
    if (is_subscription) {
      payload.plan_uuid = currentSelectedPlan.uuid;
    } else if (currentSelectedPlan.content_type === 7) {
      // PPV_EVENT = 7
      payload.event_uuid = currentSelectedPlan.uuid;
    } else {
      // PPV Package (Video/VOD/Audio/AOD)
      payload.package_uuid = currentSelectedPlan.uuid;
    }
    
    payload.offer_code = coupon_code;
    
    let res = await verifyCouponCode(baseUrl, apiKey, JSON.stringify(payload));
    if (res != undefined && res.hasOwnProperty("discounted_price")) {
      $(".price-p")
        .css({
          "text-align": "center",
          "font-size": "20px",
          color: "black",
          "text-decoration": "line-through",
        })
        .after(
          `<p class="purchase-card-price" style="text-align:center;">${res.discounted_price}</p>`
        );
      $("#coupon_apply_btn").remove();
      $("#coupon_code").attr("disabled", true);
      
      // Store the coupon code for use during purchase
      currentSelectedPlan.applied_coupon_code = coupon_code;
    }
  }
}

// Authorize Net Payment
async function authorizeNetPayment(
  baseUrl,
  apiKey,
  authorizeNetLoginId,
  authorizeNetPublicClientKey,
  data,
  container,
  is_subscription,
  isSandbox = false
) {
  let isLogged = isAuth();
  let loginToken = JSON.parse(localStorage.getItem("loginToken") || "{}");
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  let authorizeNetFormEl = null;
  let savedCards = [];

  // Fetch saved payment methods if user is logged in
  if (isLogged) {
    try {
      const savedCardsResult = await getSavedPaymentMethods(baseUrl, apiKey);
      if (savedCardsResult.success && savedCardsResult.saved_cards.length > 0) {
        savedCards = savedCardsResult.saved_cards;
        console.log("[Authorize.Net] Found saved payment methods:", savedCards.length);
      }
    } catch (err) {
      console.log("[Authorize.Net] Error fetching saved cards:", err);
    }
  }

  // Use sandbox or production Accept.js based on backend is_sandbox setting
  let accept_js_src = isSandbox 
    ? "https://jstest.authorize.net/v1/Accept.js" 
    : "https://js.authorize.net/v1/Accept.js";

  const authorize_net_script = document.createElement('script');
  authorize_net_script.src = accept_js_src;
  authorize_net_script.async = true;

  // Load Authorize.Net script
  authorize_net_script.addEventListener("load", () => {
    // Pass saved cards and login status to the purchase card
    $(createAuthorizeNetPurchaseCard(data, is_subscription, {
      authorizeNetPublicClientKey, 
      authorizeNetLoginId,
      savedCards: savedCards,
      isLoggedIn: isLogged
    })).appendTo(container);

    var planSelect = document.getElementById('plan_value');
    var submitButtonText = "Submit Payment"
    var addCardFields = false;

    if (planSelect) {
      planSelect.addEventListener('change', function() {
        var selectedOption = this.options[this.selectedIndex];
        var selectedPrice = selectedOption.getAttribute('data-price');
        var creditCardField = document.getElementById('authorize-net-credit-card-field');
        var couponField = document.getElementById('coupon-field');
        var submitButton = document.getElementById('authorize-net-submit-payment');
        var isPaidPlan = parseFloat(selectedPrice) > 0;

        if (creditCardField) {
          creditCardField.style.display = isPaidPlan ? 'flex' : 'none';
          submitButton.innerHTML = isPaidPlan ? "Submit Payment" : "Subscribe";
          
          // Initialize card form when switching to a paid plan
          if (isPaidPlan) {
            authorizeNetAddCardFields();
            createCardForm();
          }
        }

        // Hide coupon field for free plans, show for paid plans
        if (couponField) {
          couponField.style.display = isPaidPlan ? 'block' : 'none';
        }
      });
    } else {
      console.error("Element with ID 'plan_value' not found");
    }

    if ($.type(data) === "array") {
      const selectPlanDropdown = $('select[name="plan_id"]');

      if (data.length > 1) {
        selectedPlan = data[0];
        selectPlanDropdown.val(selectedPlan.uuid);
        selectPlanDropdown.change(function () {
          selectedPlan = data.find((item) => item.uuid === this.value);
          submitButtonText = "Submit Payment";
          if (selectedPlan.is_free) {
            submitButtonText = "Subscribe";
          } else {
            submitButtonText = "Submit Payment";
            addCardFields = true;
          }
        });
      } else if (data.length === 1) {
        // If there's only one plan, select it by default and trigger the change event
        selectedPlan = data[0];
        selectPlanDropdown.val(selectedPlan.uuid).change();
        submitButtonText = "Submit Payment";
        if (selectedPlan.is_free) {
          submitButtonText = "Subscribe";
        } else {
          submitButtonText = "Submit Payment";
          addCardFields = true;
        }
      }
    } else {
      // Single plan
      selectedPlan = data;
      submitButtonText = "Submit Payment";
      if (selectedPlan.is_free) {
        submitButtonText = "Subscribe";
      } else {
        submitButtonText = "Submit Payment";
        addCardFields = true;
      }
    }

    if (addCardFields & selectedPlan.is_free) {
      authorizeNetAddCardFields();
      createCardForm();
    }

    initAuthorizeNet(is_subscription, submitButtonText, selectedPlan);
  });

  document.body.appendChild(authorize_net_script);

  // init AuthorizeNet
  async function initAuthorizeNet(is_subscription, submitButtonText="Submit Payment", selectedPlan) {
    if (isLogged) {
      let user_email = loginToken.user
        ? loginToken.user.email
        : loginToken.profile.email;
      $("#email").val(user_email).attr("disabled", true);
      
      // Also pre-fill name fields if available
      let user_first_name = loginToken.user?.first_name || loginToken.profile?.first_name || '';
      let user_last_name = loginToken.user?.last_name || loginToken.profile?.last_name || '';
      if (user_first_name) {
        $("#first_name").val(user_first_name);
      }
      if (user_last_name) {
        $("#last_name").val(user_last_name);
      }
      
      // Hide password field for logged-in users
      $("#password").closest(".col").hide();
    }
    
    if (!selectedPlan.is_free) {
      authorizeNetAddCardFields();
      createCardForm();
    }

    // Handle saved card selection toggle
    const savedCardSelect = $("#saved_card_select");
    const newCardSection = $("#new-card-section");
    const nameFieldsSection = $("#form-Info-Box").first(); // First form-Info-Box contains name fields
    
    if (savedCardSelect.length > 0) {
      // Initially hide new card section AND name fields if a saved card is selected (first saved card is default)
      const initialSelectedValue = savedCardSelect.val();
      if (initialSelectedValue) {
        newCardSection.hide();
        nameFieldsSection.hide(); // Hide name fields for repeat purchase
        // Show coupon field for paid plans
        if (!selectedPlan.is_free) {
          $("#coupon-field").show();
        }
        console.log("[Authorize.Net] Using saved card by default:", initialSelectedValue);
      }
      
      // Custom dropdown toggle handler
      const customDropdownSelected = $("#custom-dropdown-selected");
      const customDropdownOptions = $("#custom-dropdown-options");
      
      // Toggle dropdown on click
      customDropdownSelected.on("click", function(e) {
        e.stopPropagation();
        customDropdownOptions.toggle();
      });
      
      // Close dropdown when clicking outside
      $(document).on("click", function(e) {
        if (!$(e.target).closest(".custom-card-dropdown").length) {
          customDropdownOptions.hide();
        }
      });
      
      // Handle option selection (click on option text, not the remove button)
      customDropdownOptions.on("click", ".custom-dropdown-option", function(e) {
        // Don't process if clicking on the remove button
        if ($(e.target).hasClass("remove-card-btn")) {
          return;
        }
        
        const $option = $(this);
        const selectedValue = $option.data("value");
        const selectedText = $option.find(".option-text").text();
        const customerId = $option.data("customer-id");
        
        // Update hidden select
        savedCardSelect.val(selectedValue).trigger("change");
        
        // Update custom dropdown display
        $(".selected-card-text").text(selectedText);
        $(".custom-dropdown-option").removeClass("selected");
        $option.addClass("selected");
        
        // Close dropdown
        customDropdownOptions.hide();
      });
      
      // Handle saved card select change (for both custom dropdown and programmatic changes)
      savedCardSelect.on("change", function() {
        const selectedValue = $(this).val();
        
        if (selectedValue) {
          // A saved card is selected - hide new card form and name fields
          newCardSection.hide();
          nameFieldsSection.hide(); // Hide name fields for repeat purchase
          // Show coupon field for paid plans
          if (!selectedPlan.is_free) {
            $("#coupon-field").show();
          }
        } else {
          // "Use a new card" selected - show new card form
          newCardSection.show();
          // Show name fields only if not logged in
          if (!isLogged) {
            nameFieldsSection.show();
          }
          if (!selectedPlan.is_free) {
            authorizeNetAddCardFields();
            createCardForm();
          }
        }
      });
      
      // Handle remove card button click (inside dropdown options)
      customDropdownOptions.on("click", ".remove-card-btn", async function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const $btn = $(this);
        const paymentMethodId = $btn.data("payment-id");
        
        if (!paymentMethodId) {
          console.log("[Authorize.Net] No payment method ID found on button");
          return;
        }
        
        $btn.prop("disabled", true).text("...");
        
        try {
          const result = await deleteSavedPaymentMethod(baseUrl, apiKey, paymentMethodId);
          
          if (result.success) {
            console.log("[Authorize.Net] Payment method removed successfully");
            
            // Remove from hidden select
            savedCardSelect.find(`option[value="${paymentMethodId}"]`).remove();
            
            // Remove the option from custom dropdown
            const $option = $btn.closest(".custom-dropdown-option");
            const wasSelected = $option.hasClass("selected");
            $option.remove();
            
            // Update the saved cards array
            savedCards = savedCards.filter(card => card.payment_method_id !== paymentMethodId);
            
            // Check if there are any saved cards left
            const remainingCards = customDropdownOptions.find(".custom-dropdown-option[data-is-saved-card='true']").length;
            if (remainingCards === 0) {
              // No more saved cards - hide the entire saved cards section and show new card form
              $("#saved-cards-section").hide();
              newCardSection.show();
              if (!selectedPlan.is_free) {
                authorizeNetAddCardFields();
                createCardForm();
              }
              if (!isLogged) {
                nameFieldsSection.show();
              }
            } else if (wasSelected) {
              // The removed card was selected, select the first remaining saved card
              const $firstOption = customDropdownOptions.find(".custom-dropdown-option[data-is-saved-card='true']").first();
              const newValue = $firstOption.data("value");
              const newText = $firstOption.find(".option-text").text();
              
              savedCardSelect.val(newValue).trigger("change");
              $(".selected-card-text").text(newText);
              $(".custom-dropdown-option").removeClass("selected");
              $firstOption.addClass("selected");
            }
            
            // Close the dropdown
            customDropdownOptions.hide();
            
            // Show success message below the payment method dropdown
            const messageDiv = $('<div class="payment-method-message success-message">Card removed successfully</div>');
            $("#saved-cards-section").append(messageDiv);
            setTimeout(() => messageDiv.remove(), 3000);
          } else {
            console.error("[Authorize.Net] Failed to remove payment method:", result.message);
            
            // Close the dropdown
            customDropdownOptions.hide();
            
            const messageDiv = $('<div class="payment-method-message error-message">' + (result.message || "Failed to remove card") + '</div>');
            $("#saved-cards-section").append(messageDiv);
            setTimeout(() => messageDiv.remove(), 3000);
          }
        } catch (err) {
          console.error("[Authorize.Net] Error removing payment method:", err);
          
          // Close the dropdown
          customDropdownOptions.hide();
          
          const messageDiv = $('<div class="payment-method-message error-message">An error occurred while removing the card</div>');
          $("#saved-cards-section").append(messageDiv);
          setTimeout(() => messageDiv.remove(), 3000);
        } finally {
          $btn.prop("disabled", false).text("×");
        }
      });
    }

    // On Submit Payment Form
    let errorDiv = $("#authorize-net-card-errors");
    authorizeNetFormEl = $("#authorize-net-payment-form");
    const authorizeNetForm = authorizeNetFormEl;
    let submitButton = $("#authorize-net-submit-payment");
    let authorizeNetCardJs = $("#authorize-net-card-element");

    submitButton.on("click", function (event) {
      event.preventDefault();
      
      var formData = new FormData(event.currentTarget.form);
      formData = Object.fromEntries(formData);
      let selectedPlan;

      if (Array.isArray(data)) {
        selectedPlan = data.find(item => item.uuid === formData.plan_id);
      } else if (data && typeof data === "object") {
        if (data.uuid) {
          selectedPlan = data;
        } else {
          selectedPlan = null; // No match found
        }
      } else {
        // Handle unexpected data types
        console.error("Unexpected data format. Expected array or object.", data);
        selectedPlan = null;
      }

      submitButton.attr("disabled", true);
      submitButton.html("Processing...");

      errorDiv.html("");
      let email = authorizeNetForm.find("#email").val();
      let first_name = authorizeNetForm.find("#first_name").val();
      let last_name = authorizeNetForm.find("#last_name").val();
      let password = authorizeNetForm.find("#password").val();
      let coupon_code = authorizeNetForm.find("#coupon_code").val();
      let card_number = authorizeNetCardJs.find("#cardNumber").val();
      let card_name = authorizeNetCardJs.find("#cardName").val();
      let expiry_date = authorizeNetCardJs.find(".expiry").val();
      let card_code = authorizeNetCardJs.find("#cardCode").val();

      const validateExpiry = (expiry) => {
        // Check if the format is MM/YY or MM/YYYY
        const expiryRegex = /^(0[1-9]|1[0-2])\/?([0-9]{2}|[0-9]{4})$/;
        expiry = expiry.replace(/\s+/g, '');
        
        if (!expiryRegex.test(expiry)) {
          return false;
        }
      
        // Split month and year
        let [month, year] = expiry.split("/");
      
        // Convert 2-digit year to 4-digit year (e.g., '23' becomes '2023')
        if (year.length === 2) {
          year = "20" + year;
        }
      
        // Convert to integers
        const currentDate = new Date();
        const expiryDate = new Date(`${year}-${month}-01`);
        
        // Set expiry to the last day of the month
        expiryDate.setMonth(expiryDate.getMonth() + 1);
        expiryDate.setDate(0);
      
        // Check if expiry date is in the future
        return expiryDate > currentDate;
      };

      // Check if using a saved card FIRST (before card validation)
      const savedCardSelect = $("#saved_card_select");
      const selectedSavedCard = savedCardSelect.length > 0 ? savedCardSelect.val() : null;
      const usingSavedCard = selectedSavedCard && isLogged;

      // Trim all fields
      const trimmedFirstName = first_name.trim();
      const trimmedLastName = last_name.trim();
      const trimmedPassword = password.trim();
      const trimmedCardNumber = card_number ? card_number.trim() : "";
      const trimmedCardName = card_name? card_name.trim() : "";
      const trimmedCardCode = card_code ? card_code.trim() : "";
      const trimmedExpiryDate = expiry_date ? expiry_date.trim() : "";
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      let isValid = true;
      let validationMessage = "Required fields are missing";

      // Validate card fields ONLY if NOT using a saved card
      if (!usingSavedCard && !trimmedCardNumber && !trimmedCardName && !trimmedCardCode && selectedPlan.price > 0) {
        isValid = false;
        validationMessage = "Card details are missing";
      } else if (!usingSavedCard && !isLogged && !trimmedFirstName) {
        // Only require name fields if NOT using saved card AND NOT logged in
        // Logged-in users will use their profile name
        isValid = false;
        validationMessage = "Enter your first name";
      } else if (!usingSavedCard && !isLogged && !trimmedLastName) {
        // Only require name fields if NOT using saved card AND NOT logged in
        // Logged-in users will use their profile name
        isValid = false;
        validationMessage = "Enter your last name";
      } else if (!emailRegex.test(email)) {
        isValid = false;
        validationMessage = "Enter a valid email address";
      } else if (!isLogged && !trimmedPassword) {
        // Only require password if not logged in
        isValid = false;
        validationMessage = "Enter your password";
      } else if (!usingSavedCard && selectedPlan.price > 0) {
        // Only validate card expiry if NOT using saved card
        isValid = validateExpiry(trimmedExpiryDate);
        validationMessage = "Card expiry date is invalid";
      }
      
      if (!isValid) {
        submitButton.attr("disabled", false);
        submitButton.html(submitButtonText);
        errorDiv.html(validationMessage);
        return false;
      }

      // For logged-in users, use their profile name (whether using saved card or new card)
      let payloadFirstName = first_name;
      let payloadLastName = last_name;
      
      if (isLogged) {
        // Use profile name for logged-in users
        payloadFirstName = loginToken.user?.first_name || loginToken.profile?.first_name || first_name;
        payloadLastName = loginToken.user?.last_name || loginToken.profile?.last_name || last_name;
      }
      
      let payload = {
        email: email,
        first_name: payloadFirstName,
        last_name: payloadLastName,
        password: password,
        uuid: selectedPlan.uuid,
      }

      if (
        coupon_code !== undefined &&
        coupon_code !== "" &&
        coupon_code !== null
      ) {
        payload["coupon_code"] = coupon_code;
      }

      // Include applied coupon code if exists
      if (selectedPlan.applied_coupon_code) {
        payload["offer_code"] = selectedPlan.applied_coupon_code;
      }

      if (
        params.hasOwnProperty("deviceType") &&
        params.hasOwnProperty("deviceId")
      ) {
        payload["deviceType"] = params.deviceType;
        payload["deviceId"] = params.deviceId;
      }

      if (is_subscription && selectedPlan.is_free) {
        capturePayment(payload, submitButton, selectedPlan);
      } else if (usingSavedCard) {
        console.log("[Authorize.Net] Using saved card:", selectedSavedCard);
        const selectedOption = savedCardSelect.find("option:selected");
        // Use unified data attribute: data-customer-id
        const customerId = selectedOption.data("customer-id");
        
        // Process payment with saved card using unified field names
        processSavedCardPayment(
          payload, 
          submitButton, 
          selectedPlan, 
          selectedSavedCard,  // This is payment_method_id
          customerId,
          is_subscription
        );
      } else {
        // NEW CARD
        var authData = {};
          authData.clientKey = authorizeNetPublicClientKey;
          authData.apiLoginID = authorizeNetLoginId;

        var myCard = $('#my-card');
        var cardData = {};
          cardData.cardNumber = myCard.CardJs('cardNumber').replace(/\s+/g, '');
          cardData.fullName = document.getElementById("cardName").value;
          cardData.month = myCard.CardJs('expiryMonth');
          cardData.year = myCard.CardJs('expiryYear');
          cardData.cardCode = myCard.CardJs('cvc');
  
        var secureData = {};
            secureData.authData = authData;
            secureData.cardData = cardData;
        console.log("Accept JS executing");

        // Use Accept.js to tokenize the card data
        Accept.dispatchData(secureData, function(response) {
          if (response && response.opaqueData) {
              // Insert capturePayment function here
              payload["opaque_card_data"] = response.opaqueData;
              capturePayment(payload, submitButton, selectedPlan);
          } else {
              console.error("Error:", response);
          }
        });
      }
    });

    // close popup form
    $("#closeAuthorizeNetPurchaseCard").click(function () {
      $("#authorizeNetPurchaseCard .payment-form").remove();
      $('#authorize-net-card-element .payment-form').remove();
      $("#authorizeNetPurchaseCard").remove();
    });

    // Apply coupon code
    $("#coupon_apply_btn").on("click", function () {
      applyCouponCode(authorizeNetForm.find("#coupon_code").val());
    });
  }

  // Capture Payment
  async function capturePayment(payload, submitButton, currentSelectedPlan) {
    let res;
    if (is_subscription) {
      res = await purchaseSubscription(
        baseUrl,
        apiKey,
        JSON.stringify(payload)
      );
    } else {
      payload["content_type"] = currentSelectedPlan.content_type;
      res = await purchasePPVOrder(baseUrl, apiKey, JSON.stringify(payload));
    }

    if (res !== undefined) {
      if ("credentials" in res && res.credentials) {
        localStorage.setItem("loginToken", JSON.stringify(res.credentials));
        isLogged = true;
        loginToken = res.credentials;
      }
      $("#authorizeNetPurchaseCard").remove();

      if (window.location.href.indexOf("/purchase-ppv-event") !== -1) {
        let current_datetime = moment();
        let event_datetime = moment(selectedPlan.event_dates.lower);
        let diff_datetime = current_datetime.diff(event_datetime, "minuts");
        if (diff_datetime >= 0) {
          $(".ppv-event-banner-btn")
            .html("Watch Now")
            .addClass("ppv_event_watch_live_btn");
        } else {
          $(".ppv-event-banner-btn").remove();
          $(".ppv-event-banner-btn-wrapper").html(`
            <p style="color:green">
              This event will start at ${moment(
                selectedPlan.event_dates.lower
              ).format("hh:mm A")} on ${moment(
            selectedPlan.event_dates.lower
          ).format("ll")} you will be able to watch it by going to this page 
              <b><a href="#" class="ppv_event_watch_live_btn">${
                selectedPlan.title
              }</a></b>
            </p>
          `);
        }

        $(".ppv_event_watch_live_btn").on("click", function () {
          const nextURL = `/watch-live`;
          window.location = formatUrl(nextURL);
        });
      } else {
        window.location.reload();
      }
    } else {
      console.log("error");
      console.log(res);
    }

    submitButton.attr("disabled", false);
    submitButton.html("Submit Payment");
  }

  // Process payment using a saved card (repeat purchase)
  // Uses the SAME capturePayment function but with saved_payment_profile in payload
  // Unified field names: customer_id and payment_method_id (works for both Stripe and Authorize.Net)
  async function processSavedCardPayment(payload, submitButton, currentSelectedPlan, paymentMethodId, customerId, isSubscription) {
    // Add saved_payment_profile to the payload - this tells backend to use saved card
    // instead of opaque_card_data
    // Uses unified field names that work for both gateways
    payload.saved_payment_profile = {
      customer_id: customerId,
      payment_method_id: paymentMethodId
    };
    
    // Use the SAME capturePayment function - ensures identical processing
    capturePayment(payload, submitButton, currentSelectedPlan);
  }

  // Apply Coupon Code
  async function applyCouponCode(coupon_code) {
    if (!authorizeNetFormEl || authorizeNetFormEl.length === 0) {
      console.error("Authorize.Net form not initialized, cannot apply coupon.");
      return;
    }
    // Get the currently selected plan from the form
    let currentSelectedPlan;
    if (Array.isArray(data)) {
      const selectedPlanId = authorizeNetFormEl.find("select[name='plan_id']").val();
      currentSelectedPlan = data.find(item => item.uuid === selectedPlanId);
    } else if (data && typeof data === "object") {
      currentSelectedPlan = data;
    } else {
      console.error("Unexpected data format for coupon code application.");
      return;
    }

    if (!currentSelectedPlan) {
      console.error("No plan selected for coupon code application.");
      return;
    }

    // Determine the correct UUID field based on whether this is a subscription or PPV purchase
    let payload = {};
    
    if (is_subscription) {
      payload.plan_uuid = currentSelectedPlan.uuid;
    } else if (currentSelectedPlan.content_type === 7) {
      // PPV_EVENT = 7
      payload.event_uuid = currentSelectedPlan.uuid;
    } else {
      // PPV Package (Video/VOD/Audio/AOD)
      payload.package_uuid = currentSelectedPlan.uuid;
    }
    
    payload.offer_code = coupon_code;
    
    let res = await verifyCouponCode(baseUrl, apiKey, JSON.stringify(payload));
    if (res != undefined && res.hasOwnProperty("discounted_price")) {
      $(".price-p")
        .css({
          "text-align": "center",
          "font-size": "20px",
          color: "black",
          "text-decoration": "line-through",
        })
        .after(
          `<p class="purchase-card-price" style="text-align:center;">${res.discounted_price}</p>`
        );
      $("#coupon_apply_btn").remove();
      $("#coupon_code").attr("disabled", true);
      
      // Store the coupon code for use during purchase
      currentSelectedPlan.applied_coupon_code = coupon_code;
    }
  }
}

async function dpoPayPayment(baseUrl, apiKey, companyToken, serviceToken, data, container, is_subscription) {
  const isLogged = isAuth();
  let loginToken = JSON.parse(localStorage.getItem("loginToken") || "{}");
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  // Render the payment form
  $(container).html(createDPOPayPurchaseCard(data, is_subscription, { isLoggedIn: isLogged }));
  const form = $(container).find(".purchase-card");
  const submitButton = $(container).find("#dpo-pay-submit-payment");
  if (is_subscription) {
    submitButton.html("Proceed to Payment");
  } else {
    submitButton.html("Subscribe");
  }

  // Event listener for the dropdown
  const planSelect = form.find("select[name='plan_id']");
  planSelect.on("change", function () {
    const selectedPlanId = $(this).val();
    const selectedPlan = data.find((plan) => plan.uuid === selectedPlanId);

    if (selectedPlan && selectedPlan.is_free) {
      // Change submit button text for free plans
      submitButton.html("Subscribe");
    } else {
      // Default text for paid plans
      if (is_subscription) {
        submitButton.html("Proceed to Payment");
      } else {
        submitButton.html("Subscribe");
      }
    }
  });

  /**
    * Handles form submission for payment.
    */
    submitButton.on("click", async (event) => {
      event.preventDefault();
      const errorDiv = $("#dpo-pay-card-errors");

      const plan_id = is_subscription ? form.find("select[name='plan_id']").val() : null;
      const firstName = form.find("input[name='first_name']").val().trim();
      const lastName = form.find("input[name='last_name']").val().trim();
      const email = form.find("input[name='email']").val().trim();
      const password = form.find("input[name='password']").val().trim();

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const validationMessage =
        !firstName ? "Enter your first name!" :
        !lastName ? "Enter your last name!" :
        !emailRegex.test(email) ? "Enter a valid email address!" :
        !password ? "Enter your password!" :
        (is_subscription && !plan_id) ? "Select a plan!" :
        null;

      if (validationMessage) {
        errorDiv.text(validationMessage);
        return;
      }

      const now = new Date();
      const formattedDate = `${now.getFullYear()}/${String(now.getMonth() + 1).padStart(2, "0")}/${String(now.getDate()).padStart(2, "0")} ${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}`;

      const selectedPlan = is_subscription
        ? data.find((plan) => plan.uuid === plan_id)
        : data;

      if (!selectedPlan) {
        errorDiv.text("Selected plan not found.");
        return;
      }

      if (selectedPlan.is_free) {
        const payload = {
          email,
          first_name: firstName,
          last_name: lastName,
          password,
          uuid: plan_id,
        };
        const response = await purchaseSubscription(baseUrl, apiKey, JSON.stringify(payload));
        if (response?.credentials) {
          localStorage.setItem("loginToken", JSON.stringify(response.credentials));
          window.location.reload();
        } else {
          errorDiv.text("An error occurred while processing your request.");
        }
      }

      const xmlPayload = `<?xml version="1.0" encoding="utf-8"?>
        <API3G>
          <CompanyToken>${companyToken}</CompanyToken>
          <Request>createToken</Request>
          <Transaction>
            <PaymentAmount>${selectedPlan.price}</PaymentAmount>
            <PaymentCurrency>${selectedPlan.price_currency}</PaymentCurrency>
            <PTL>5</PTL>
            <customerFirstName>${firstName}</customerFirstName>
            <customerLastName>${lastName}</customerLastName>
            <customerEmail>${email}</customerEmail>
            <AllowRecurrent>1</AllowRecurrent>
          </Transaction>
          <Services>
            <Service>
              <ServiceType>${serviceToken}</ServiceType>
              <ServiceDescription>${selectedPlan.title}</ServiceDescription>
              <ServiceDate>${formattedDate}</ServiceDate>
            </Service>
          </Services>
          <Additional>
            <BlockPayment>BT</BlockPayment>
            <BlockPayment>PP</BlockPayment>
          </Additional>
        </API3G>`;

      try {
        const res = await generateDpoPayPortal(baseUrl, apiKey, xmlPayload);
        const transactionToken = res.split("ID=")[1];

        const paymentWindow = window.open(res, "_blank", "width=800,height=600");
        const interval = setInterval(async () => {
          if (paymentWindow.closed) {
            clearInterval(interval);

            const verifyResponse = await verifyTransaction(baseUrl, apiKey, companyToken, transactionToken);
            if (verifyResponse.success) {
              const payload = {
                TransToken: transactionToken,
                VerificationDetails: verifyResponse,
                email,
                first_name: firstName,
                last_name: lastName,
                password,
              };

              if (is_subscription) {
                payload["uuid"] = plan_id;
                // Include coupon code for subscription if applied
                if (selectedPlan.applied_coupon_code) {
                  payload["offer_code"] = selectedPlan.applied_coupon_code;
                }
              } else {
                payload["uuid"] = data.uuid;
                payload["content_type"] = data.content_type;
                // Include coupon code for PPV purchase if applied
                if (selectedPlan.applied_coupon_code) {
                  payload["offer_code"] = selectedPlan.applied_coupon_code;
                }
              }

              const purchaseMethod = is_subscription ? purchaseSubscription : purchasePPVOrder;
              const response = await purchaseMethod(baseUrl, apiKey, JSON.stringify(payload));

              if (response?.credentials) {
                localStorage.setItem("loginToken", JSON.stringify(response.credentials));
                window.location.reload();
              } else {
                errorDiv.text("An error occurred while processing your request.");
              }
            } else {
              errorDiv.text("Transaction verification failed.");
            }
          }
        }, 1000);
      } catch (error) {
        errorDiv.text("An error occurred while processing the payment.");
      }
    });

  $("#closeDPOPayPurchaseCard").on("click", closePaymentForm);

  function closePaymentForm() {
    $("#DPOPayPurchaseCard, #dpo-pay-card-element .payment-form").remove();
  }
}

export const registerCancelCheckoutOrder = () => {
  $(".cancel-redirect").click(function () {
    redirectTo();
  });

  $(".do-redirect").click(function () {
    redirectTo();
  });
};
